import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPendenciaById } from "../services/pendenciaService";
import { getCustomers } from "../services/customerService";

const PendenciasMobileForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [pendencia, setPendencia] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [equipments, setEquipments] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pendenciaData, customersData] = await Promise.all([
          getPendenciaById(id),
          getCustomers(1, 100),
        ]);

        const cliente = customersData.customers.find((c) =>
          c.equipment.some(
            (equip) => equip.equipmentNumber === pendenciaData.equipamentoNumero
          )
        );

        setPendencia({
          ...pendenciaData,
          clienteId: cliente?._id || "",
          dataApontamento: pendenciaData.dataApontamento
            ? new Date(pendenciaData.dataApontamento).toISOString().split("T")[0]
            : "",
        });

        setCustomers(customersData.customers);
        setEquipments(cliente?.equipment || []);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPendencia((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Pendência enviada:", pendencia);
    alert("Pendência salva com sucesso!");
  };

  if (!pendencia) {
    return <p>Carregando pendência...</p>;
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Editar Pendência</h2>
      <form onSubmit={handleSubmit}>
        {/* Cliente */}
        <div style={styles.inputGroup}>
          <label style={styles.label}>Cliente:</label>
          <select
            name="clienteId"
            value={pendencia.clienteId || ""}
            disabled
            style={styles.selectDisabled}
          >
            {customers.map((cliente) => (
              <option key={cliente._id} value={cliente._id}>
                {cliente.name}
              </option>
            ))}
          </select>
        </div>

        {/* Equipamento */}
        <div style={styles.inputGroup}>
          <label style={styles.label}>Equipamento:</label>
          <select
            name="equipamentoNumero"
            value={pendencia.equipamentoNumero || ""}
            onChange={handleChange}
            style={styles.select}
          >
            {equipments.map((equip) => (
              <option key={equip.equipmentNumber} value={equip.equipmentNumber}>
                {equip.equipmentNumber} - {equip.type}
              </option>
            ))}
          </select>
        </div>


        {/* Situação */}
        <div style={styles.inputGroup}>
          <label style={styles.label}>Situação:</label>
          <select
            name="situacaoEquipamento"
            value={pendencia.situacaoEquipamento || ""}
            onChange={handleChange}
            style={styles.select}
          >
            <option value="Funcionando">Funcionando</option>
            <option value="Parado">Parado</option>
          </select>
        </div>

        {/* Data */}
        <div style={styles.inputGroup}>
          <label style={styles.label}>Data:</label>
          <input
            type="date"
            name="dataApontamento"
            value={pendencia.dataApontamento || ""}
            onChange={handleChange}
            style={styles.input}
          />
        </div>

        {/* Descrição */}
        <div style={styles.inputGroup}>
          <label style={styles.label}>Descrição:</label>
          <input
            type="text"
            name="descricaoPendencia"
            value={pendencia.descricaoPendencia || ""}
            onChange={handleChange}
            style={styles.input}
          />
        </div>

        {/* Botões */}
        <div style={styles.buttonContainer}>
          <button
            type="button"
            onClick={() => navigate("/pendencias-mobile")}
            style={styles.buttonCancel}
          >
            Voltar
          </button>
          <button type="submit" style={styles.buttonSubmit}>
            Salvar
          </button>
        </div>
      </form>
    </div>
  );
};

const styles = {
  container: {
    padding: "5%",
    backgroundColor: "#fff",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    textAlign: "center",
    marginBottom: "5%",
    fontSize: "4.7rem", // Aumentado em 150%
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "3%",
  },
  label: {
    marginBottom: "2%",
    fontSize: "3.1rem", // Aumentado em 150%
  },
  select: {
    width: "100%",
    padding: "3%", // Aumentado
    fontSize: "3.7rem", // Aumentado em 150%
  },
  selectDisabled: {
    width: "100%",
    padding: "3%", // Aumentado
    fontSize: "3.7rem", // Aumentado em 150%
    backgroundColor: "#f0f0f0",
  },
  input: {
    width: "94%",
    padding: "3%", // Aumentado
    fontSize: "3.7rem", // Aumentado em 150%
  },
  buttonContainer: {
    marginTop: "auto",
    display: "flex",
    justifyContent: "space-between",
    gap: "5%",
  },
  buttonCancel: {
    marginTop:"3rem",
    flex: "1",
    padding: "4%", // Aumentado
    backgroundColor: "#f5f5f5",
    border: "1px solid #ccc",
    fontSize: "3.4rem", // Aumentado em 150%
  },
  buttonSubmit: {
    marginTop:"3rem",
    flex: "1",
    padding: "4%", // Aumentado
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    fontSize: "3.4rem", // Aumentado em 150%
  },
};

export default PendenciasMobileForm;
